import { HttpErrorResponse } from '@angular/common/http';
import { HostListener, OnInit, ViewChild } from '@angular/core';
import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { environment } from '../../../environments/environment';
import { ConfigDetails } from '../../models/appConfig.model';
import { ContractSession } from '../../models/contractsession.model';
import { AzureMedia, ContractsAzureDetailsResponse, ContractsSingalFile, GenerateContractsAzure } from '../../models/document.model';
import { CLPUserRoleResponse, FeaturePermissions, UserResponse } from '../../models/user.model';
import { BillingService } from '../../services/billing.service';
import { ContractSessionService } from '../../services/contractsession.service';
import { DocumentService } from '../../services/document.service';
import { AppconfigService } from '../../services/shared/appconfig.service';
import { UtilityService } from '../../services/shared/utility.service';
import { UserService } from '../../services/user.service';

//For jquery
declare var $: any;

@Component({
    selector: 'app-corp-contract',
    templateUrl: './corp-contract.component.html',
    styleUrls: ['./corp-contract.component.css']
})
/** crop-contract component*/
export class CorpContractComponent implements OnInit {
    /** crop-contract ctor */

    //displayedGenContractColumns = ['fileName', 'dtCreated', 'Documents'];
    displayedGenContractColumns = ['fileName', 'dtCreated', 'unZipDoc', 'zipDoc'];
    displayedSingleFileColumns = ['fileName', 'unZipDoc'];
    dataSourceGenContract: any;
    dataSourceSingleFile: any;
    @ViewChild('sortCust') sortCust: MatSort;
    @ViewChild('sortDocPopUp') sortDocPopUp: MatSort;
    gencontractDetailsResponse: ContractsAzureDetailsResponse;
    clpUserRoleResponse: CLPUserRoleResponse;
    generateContractsAzure: GenerateContractsAzure[];
    generateContractsMedia: GenerateContractsAzure[];
    private configDetails: ConfigDetails;
    contractSessionId: any;
    public contractSession: ContractSession;
    userId: number;
    containerName: string = 'contih';
    isUserAuth: boolean = false;
    isExecuted: boolean = false;
    encryptedUser: string = 'dfsfsdjfjsdfj';
    contactId: number;
    panelTitle: string = "All Contracts";
    mySoUrl: any;
    userResponse: UserResponse;
    permissionResponse: FeaturePermissions;
    userMessage: string;
    userPermission: boolean = false;
    inventHelpURL: any;
    loading: boolean = false;
    popLoading: boolean = false;
    pop2Loading: boolean = false;
    singalDownload: ContractsSingalFile[] = [];
    receivedRole: boolean = false;
    approvalRole: boolean = false;
    isPendingNetSuiteTransactions: boolean = true;
    logoPath: string = "";
    public appVersion;

    constructor(private _route: ActivatedRoute,
        private _documentService: DocumentService,
        private _userService: UserService,
        private _appconfigService: AppconfigService,
        private _utilityService: UtilityService,
        private _contractSessionService: ContractSessionService,
        private _billingService: BillingService,
        private _snackBar: MatSnackBar) {
        this.appVersion = environment.appVersion;
        this._route.paramMap.subscribe(async params => {
            if (params.has('contact')) {
                this.contactId = +params.get('contact');
            }

            if (params.has('contractSessionId')) {
                this.contractSessionId = +params.get('contractSessionId');
                this.loadContractSession();
            }

            if (params.has('userId')) {
                this.userId = +params.get('userId');
            }
        });

    }

    ngOnInit(): void { }

    private loadContractSession() {
        if (this.contractSessionId > 0 && !isNullOrUndefined(this.contractSessionId)) {
            this._contractSessionService.getContactSessionByCSIdAsync(this.encryptedUser, this.contractSessionId)
                .then(async res => {
                    if (res) {
                        this.contractSession = UtilityService.clone(res);
                        //this.logoPath = this.contractSession.productId > 8 ? "assets/images/logo/Patent-Plus.png" : "assets/images/logo/logo_1226.png";
                        this.logoPath = "assets/images/logo/logo_1226.png";
                        this.userAuthenticate();
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async userAuthenticate() {
        await this.getMySoSite();
        let url = this.mySoUrl.configValue;
        let inventHelpUrlValue = this.inventHelpURL.configValue;
        this._route.queryParamMap.subscribe(params => {
            if (params.has('r')) {
                this.encryptedUser = params.get('r');
                this._userService.getAuthenticateR(this.encryptedUser)
                    .then(res => {
                        if (res) {
                            if (res.isvalid) {
                                this.userResponse = UtilityService.clone(res);
                                console.log("Valid User");
                                this.permissionResponse = this.userResponse.user.clientServicesPermissions;
                                if ((this.permissionResponse.view) || (this.permissionResponse.create) || (this.permissionResponse.delete) || (this.permissionResponse.edit)) {
                                    this.userPermission = false;
                                    this.isUserAuth = true;
                                    this.isExecuted = true;
                                    this.GetGenerateContractDetails();
                                    this.getPendingNetsuiteTransactions();
                                }
                                else {
                                    this.userPermission = true;
                                    this.userMessage = this.userResponse.user.firstName + " " + this.userResponse.user.lastName + " don't have permission to download contract.";
                                }
                            } else {
                                this.userPermission = true;
                                this.userMessage = "You don't have permission to download contract.";
                            }
                        } else {
                            $(location).attr('href', url + "?ReturnUrl=" + encodeURIComponent(inventHelpUrlValue + "/corp-contract/" + this.contactId + "/" + this.contractSessionId + "&c=con&i=cl"));
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        console.log("Client side Error : " + err);
                        this._utilityService.handleErrorResponse(err);
                    });
            }
            else {
                console.log('no r');
                $(location).attr('href', url + "?ReturnUrl=" + encodeURIComponent(inventHelpUrlValue + "/corp-contract/" + this.contactId + "/" + this.contractSessionId + "&c=con&i=cl"));
            }
        });
    }

    async GetGenerateContractDetails() {
        await this._documentService.getContractsAzureDetailsAsync(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res)
                    this.gencontractDetailsResponse = UtilityService.clone(res);

                if (this.gencontractDetailsResponse) {
                    this.generateContractsAzure = UtilityService.clone(this.gencontractDetailsResponse.getGenerateContractsAzure);

                    if (this.generateContractsAzure) {
                        this.isUserAuth = true;
                        this.isExecuted = this.generateContractsAzure.find(rows => rows.filePath != '' && rows.productId > 0) ? true : false;
                        const ELEMENT_DATA: GenerateContractsAzure[] = this.generateContractsAzure;
                        this.dataSourceGenContract = new MatTableDataSource(ELEMENT_DATA.filter(rows => rows.filePath != '' && rows.productId > 0));
                        this.generateContractsMedia = ELEMENT_DATA.filter(rows => rows.filePath == '' && rows.productId == 0);
                        this.checkUserRole();
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);

            });
    }

    downloadFile(fileName, containerName, source) {
        if (source == 'popup')
            this.popLoading = true;
        else
            this.loading = true;
        this._documentService.getContractsAzureZipEncriptAsync("asgdha", fileName, containerName, "AllFiles", 0, false)
            .then(async (result: any) => {
                if (result) {
                    let file = new Blob([result], { type: 'application/zip' });
                    let fileURL = URL.createObjectURL(file);
                    let fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.download = fileName;
                    fileLink.click();
                    this.popLoading = false;
                    this.loading = false;

                } else {
                    console.log("exportTozip.statusCode: Error Getting Data");
                    this.popLoading = false;
                    this.loading = false;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.popLoading = false;
                this.loading = false;
                this._utilityService.handleErrorResponse(err);

            });

    }

    async getCompressedFiles(fileName: string, containerName: string, source: string) {
        if (source == 'popup')
            this.popLoading = true;
        else
            this.loading = true;
        this._documentService.getCompressedFileNamesAsync(this.encryptedUser, fileName, containerName, 0, false)
            .then(async (result: any) => {
                if (result) {
                    var str_array = result.split(',');
                    this.createListItem(fileName, str_array);
                    this.loading = false;
                    this.popLoading = false;
                } else {
                    this.loading = false;
                    this.popLoading = false;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.loading = false;
                this.popLoading = false;
                this._utilityService.handleErrorResponse(err);
            });

    }

    async playMedia(fileName: string) {
        let azureMedia = {} as AzureMedia;
        azureMedia.contractSessionId = this.contractSessionId;
        azureMedia.fileName = fileName;
        this._documentService.getROIVideoURL(azureMedia, this.encryptedUser)
            .then(async (url: any) => {
                if (url) {
                    window.open(url, '_blank');
                }
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    createListItem(fileName: string, str_array: any): void {
        this.singalDownload = [];
        for (var i = 0; i < str_array.length; i++) {
            this.singalDownload.push({ zipName: fileName, fileName: str_array[i] });
        }
        const ELEMENT_DATA: ContractsSingalFile[] = UtilityService.clone(this.singalDownload);;
        this.dataSourceSingleFile = new MatTableDataSource(ELEMENT_DATA);
        this.dataSourceSingleFile.sort = this.sortDocPopUp;
        $('#modalExportCompressFile').modal('show');
    }
    downloadSingalFile(zipName, containerName, fileName) {
        this.pop2Loading = true;
        var fileExtensio = fileName.split('.').pop();
        this._documentService.getContractsAzureZipEncriptAsync(this.encryptedUser, zipName, containerName, fileName, 0, false)
            .then(async (result: any) => {
                if (result) {
                    if (fileExtensio.toLowerCase() == 'pdf') {
                        let file = new Blob([result], { type: 'application/pdf' });
                        window.open(URL.createObjectURL(file), '_blank')
                    }
                    else {
                        let file = new Blob([result]);
                        let fileURL = URL.createObjectURL(file);
                        let fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.download = fileName;
                        fileLink.click();
                    }
                    this.pop2Loading = false;
                    this.loading = false;
                    this.popLoading = false;
                }
                else {
                    this.pop2Loading = false;
                    this.loading = false;
                    this.popLoading = false;
                }
            }).catch((err: HttpErrorResponse) => {
                this.pop2Loading = false;
                this.loading = false;
                this.popLoading = false;
                this._utilityService.handleErrorResponse(err);
            });
    }
    async downloadUnZipFile(fileName: string, containerName: string, source: string) {

        this.popLoading = true;
        this._documentService.getContractsAzureZipEncriptAsync(this.encryptedUser, fileName, containerName, "AllFiles", 0, false)
            .then(async (result: any) => {
                if (result) {
                    console.log('downloadFile-' + result);
                    let file = new Blob([result], { type: 'application/zip' });

                    let fileURL = URL.createObjectURL(file);
                    let fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.download = fileName;
                    fileLink.click();
                    this.popLoading = false;
                } else {
                    console.log("exportToZIP.statusCode: Error Getting Data");
                    this.popLoading = false;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.popLoading = false;
                this._utilityService.handleErrorResponse(err);
            });

    }

    async getMySoSite() {
        let configValues = !isNullOrUndefined(this.contractSession) && this.contractSession.productId >= 9 && this.contractSession.productId < 12 ? "PatentPlusRedirect" : "InventHelpRedirect";
        await this._appconfigService.getAppConfigValues(this.encryptedUser, ["mySOAPP", configValues]).
            then(async (result: any) => {
                var resultvalue = UtilityService.clone(result);
                this.mySoUrl = resultvalue.filter(i => i.configKey == "mySOAPP")[0];
                this.inventHelpURL = resultvalue.filter(i => i.configKey == configValues)[0];
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    hideFilesList() {
        $('#modalExportCompressFile').modal('hide');
    }

    contractReceive() {
        this._contractSessionService.createContractReceiveAsync(this.encryptedUser, this.contractSessionId, this.userResponse.user.clpUserId)
            .then(res => {
                this.openSnackBar("The Contract has been mark received.", "");
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    contractApproval() {
        this._contractSessionService.createContractApprovalAsync(this.encryptedUser, this.contractSessionId, this.userResponse.user.clpUserId)
            .then(res => {
                if (res > 0)
                    this.createNetSuiteTransactions();
                else
                    this.openSnackBar("Contract Approval process failed. Please try again or contact administrator.", "");
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    async checkUserRole() {
        await this._userService.getRoleByCLPUser(this.encryptedUser, this.userResponse.user.clpUserId)
            .then(res => {
                if (res) {
                    if (res.statusCode == 0) {
                        this.clpUserRoleResponse = UtilityService.clone(res);
                        this.receivedRole = this.clpUserRoleResponse.listUserRole.filter(roles => roles.roleName == "Received Contracts").length > 0 ? true : false;
                        this.approvalRole = this.clpUserRoleResponse.listUserRole.filter(roles => roles.roleName == "Contract Approval").length > 0 && this.isPendingNetSuiteTransactions ? true : false;
                    }
                    else
                        console.log("GetRoleByCLPUser result status code: " + res.statusCode);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getPendingNetsuiteTransactions() {
        await this._billingService.getPendingNetSuiteTransactionsAsync(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res)
                    this.isPendingNetSuiteTransactions = false;
                else
                    this.isPendingNetSuiteTransactions = true;
            })
            .catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    createNetSuiteTransactions() {
        this._billingService.createNetSuiteTransactionsAsync(this.encryptedUser, this.contractSessionId)
            .then(res => {
                if (res > 0) {
                    this.approvalRole = false;
                    this.openSnackBar("Contract is approved and NetSuite process has been triggered.", "");
                }
                else
                    this.openSnackBar("Failure while triggering Netsuite process. Please try again or contact administrator.", "");
            }).catch((err: HttpErrorResponse) => {
                this._utilityService.handleErrorResponse(err);
            });
    }

    openSnackBar(message: string, action: string, durationTime: number = 5000) {
        this._snackBar.open(message, action, {
            verticalPosition: 'top',
            horizontalPosition: 'right',
            duration: durationTime,
        });
    }
}
